/**
 * Merge "b" object values if exits and fallback on "a" object values
 */
export function mergeObject<T extends Record<string, unknown>>(
  a: T,
  b: Record<string, string>,
) {
  return Object.keys(a).reduce(
    (acc, key) => ({
      ...acc,
      [key]: b[key] || a[key as keyof T],
    }),
    {} as T,
  )
}
